import styled from 'styled-components';

export const Value = styled.span`
  color: ${props => props.theme.palette.text.light};
  font-size: ${props => props.theme.typography.sizes.body1};
  font-weight: ${props => props.theme.typography.weight.bold};

  &.linethrough {
    text-decoration: line-through;
  }

  &.green {
    color: ${props => props.theme.palette.primary.main};
  }
`;
